// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Templates = function Templates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#templates-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.857 2.143a.716.716 0 0 0-.714.714v14.286c0 .393.321.714.714.714h10v-3.571c0-.79.639-1.429 1.429-1.429h3.571v-10a.716.716 0 0 0-.714-.714zm10 17.857h-10A2.86 2.86 0 0 1 0 17.143V2.857A2.86 2.86 0 0 1 2.857 0h14.286A2.86 2.86 0 0 1 20 2.857v10.246c0 .759-.3 1.486-.835 2.022l-4.04 4.04a2.86 2.86 0 0 1-2.022.835z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "templates-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
